import PropTypes from 'prop-types';

import { Avatar, Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';

import { customer } from 'evee-ui-common/types';

import styles from './styles';

const UserAvatar = ({ account, loading, classes, ...rest }) => (
  <Box display="flex" className={classes.avatarContainer} {...rest}>
    {loading ? (
      <Skeleton variant="circle">
        <Avatar className={classes.avatar} />
      </Skeleton>
    ) : (
      <Avatar src={account.photo} alt={account.fullName} className={classes.avatar} />
    )}
  </Box>
);

UserAvatar.propTypes = {
  loading: PropTypes.bool.isRequired,
  account: customer.customerPropType.isRequired,
  classes: PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    avatarContainer: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(UserAvatar);
